<template>
	<map-index />
</template>